import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { CommunitySpaceMember } from '~/interfaces/community';

import { Avatar } from '../../ui/Avatar';
import { ListDialog } from '../../ui/ListDialog';

import { MemberFeedShell } from '../../../members/$id/_components/MemberFeedShell';
import { MemberListRowSkeleton, MemberListSkeleton } from '../../../members/$id/_components/MemberListRowSkeleton';

interface SpaceMembersDialogProps {
  isOpen: boolean;
  onClose: () => void;
  spaceName: string;
  countLabel: string;
  members: CommunitySpaceMember[];
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
  isError: boolean;
}

export const SpaceMembersDialog: FC<SpaceMembersDialogProps> = ({
  isOpen,
  onClose,
  spaceName,
  countLabel,
  members,
  ...feed
}) => {
  const { t } = useTranslation();

  return (
    <ListDialog
      isOpen={isOpen}
      onClose={onClose}
      title={spaceName}
      header={<p className="mt-1 text-[13px] text-black/50">{countLabel}</p>}
    >
      <MemberFeedShell
        items={members}
        {...feed}
        renderItem={(member) => {
          const name = member.name || t('community.join.former_member');
          return (
            <div className="flex items-center gap-3 py-2">
              <Avatar src={member.avatar_url} alt={name} className="size-9" />
              <span className="truncate text-[15px] font-medium leading-5 text-black">{name}</span>
            </div>
          );
        }}
        getItemKey={(member) => member.id}
        emptyHeading={countLabel}
        initialSkeleton={<MemberListSkeleton />}
        nextPageSkeleton={<MemberListRowSkeleton />}
        listClassName="flex flex-col"
      />
    </ListDialog>
  );
};
